"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinnSmall = void 0;
var react_1 = __importDefault(require("react"));
var adaptive_1 = __importDefault(require("./adaptive"));
var FinnSmall = function (_a) {
    var fill = _a.fill, title = _a.title, background = _a.background, rest = __rest(_a, ["fill", "title", "background"]);
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 20 20", fill: "none" }, rest),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("circle", { cx: "10", cy: "10", r: "10", fill: fill }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 17.444665,13.64576 V 6.3853393 c 0,-0.1432 -0.1074,-0.25972 -0.2394,-0.25972 h -6.69034 c -0.132,0 -0.23935,0.11652 -0.23935,0.25972 V 13.90536 h 6.92969 c 0.132,0 0.2394,-0.1165 0.2394,-0.2596 z", fill: "#06befb" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m 4.9220353,6.1256193 h -2.11664 c -0.132,0 -0.23936,0.11652 -0.23936,0.25972 V 13.64576 c 0,0.1431 0.10736,0.2596 0.23936,0.2596 h 6.9321 v -2.5558 c 0,-2.8805107 -2.1602,-5.2239407 -4.81546,-5.2239407 z", fill: "#0063fb" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 2.5660153,13.64546 V 6.3851193 c 0,-0.1432 0.10736,-0.25971 0.23936,-0.25971 h 2.11664 c 2.65526,0 4.81545,2.34343 4.81545,5.2239507 v 2.5558 h -6.93209 c -0.132,0 -0.23936,-0.1165 -0.23936,-0.2597 z m 14.8787497,0 c 0,0.1432 -0.1074,0.2597 -0.2394,0.2597 h -6.92977 V 6.3851193 c 0,-0.1432 0.10736,-0.25971 0.23936,-0.25971 h 6.69041 c 0.132,0 0.2394,0.11651 0.2394,0.25971 z m -0.2394,-8.1038207 h -6.69041 c -0.42869,0 -0.7774897,0.37837 -0.7774897,0.84348 v 2.42807 c -0.86948,-1.935 -2.70123,-3.27155 -4.81545,-3.27155 h -2.11664 c -0.4287,0 -0.77749,0.37837 -0.77749,0.84348 V 13.64546 c 0,0.4651 0.34879,0.8435 0.77749,0.8435 H 17.205365 c 0.4287,0 0.7775,-0.3784 0.7775,-0.8435 V 6.3851193 c 0,-0.46511 -0.3488,-0.84348 -0.7775,-0.84348 z", fill: "#ffffff" })));
};
exports.FinnSmall = FinnSmall;
var Finn = function (props) {
    var _a = props.fill, fill = _a === void 0 ? '#06BEFB' : _a, rest = __rest(props, ["fill"]);
    return react_1.default.createElement(adaptive_1.default, __assign({ small: exports.FinnSmall, fill: fill, shift: -10 }, rest));
};
exports.default = Finn;
